<template>
    <li class="mb-5 px-5 pb-5 aside-user-info">
        <div class="d-flex justify-content-center align-items-center">
            <a :href="$route('user.edit', [user.url_key])">
                <div class="symbol symbol-45 symbol-light-primary flex-shrink-0 mr-3">
                        <span
                            class="symbol-label bg-primary-o-75 font-weight-bolder font-size-lg">{{
                                $initials(user.name)
                            }}</span>
                </div>
            </a>
            <div class="text-light">
                <div class="h6">
                    <small
                        class="text-primary opacity-75"><strong>{{ $page.props.agency.name }}</strong></small><br>
                    <strong class="text-primary">{{ user.name }}</strong>
                </div>
                <div class="btn-group">
                    <a :href="$route('user.edit', [user.url_key])"
                       class="btn btn-xs py-2 px-4 btn-transparent-secondary"><i
                        class="fas fa-wrench"></i></a>
                    <a :href="$route('logout')"
                       class="btn btn-xs py-2 px-4 btn-transparent-secondary"><i
                        class="fas fa-sign-out-alt"></i> {{ __('actions.sign_out') }}</a>
                </div>
            </div>
        </div>
    </li>
</template>

<script>

export default {
    props: {
        user: Object,
    },
}
</script>
